import { FiTarget, FiEye, FiHeart } from 'react-icons/fi';
import SectionHeading from './SectionHeading';
import useReveal from './useReveal';

const pillars = [
  {
    icon: FiTarget,
    title: 'Mission',
    text: 'We build powerful digital solutions that simplify operations, boost online presence, and accelerate growth—delivered with unmatched quality and client focus.',
  },
  {
    icon: FiEye,
    title: 'Vision',
    text: 'To be the world’s most trusted tech partner, revolutionizing industries through innovative software that sets new standards.',
  },
  {
    icon: FiHeart,
    title: 'Ethics',
    text: 'Client success first. We operate with integrity, protect your ideas fiercely, and deliver solutions that exceed expectations—every time.',
  },
];

function Whyus() {
  const ref = useReveal();

  return (
    <div ref={ref} className="section-pad glow-dark">
      <div className="wrap">
        <SectionHeading
          dark
          eyebrow="Why us"
          title={<>A partner that <span className="text-gradient">delivers</span></>}
          lede="Businesses trust us for on-time delivery of high-quality web and mobile apps that drive results. We combine top developers with strict standards to build reliable, scalable solutions tailored to your needs."
        />

        <div className="mt-14 grid gap-5 md:grid-cols-3">
          {pillars.map(({ icon: Icon, title, text }, index) => (
            <div
              key={title}
              className="reveal card-glass group p-7"
              data-reveal
              style={{ '--d': `${index * 80}ms` }}
            >
              <span className="icon-tile">
                <Icon size={20} />
              </span>
              <h3 className="display-md mt-6 text-white">{title}</h3>
              <p className="mt-3 text-subtle">{text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Whyus;
